import { AbstractController } from '@/Emulator/Controller/AbstractController';

export class KeyboardController extends AbstractController
{
    public readonly name: string = 'Keyboard';

    constructor()
    {
        super();

        window.addEventListener('keydown', this.onKeyDown);
        window.addEventListener('keyup', this.onKeyUp);
    }

    private readonly onKeyDown: KeyboardEventListener = (event: KeyboardEvent): void => {
        this.dispatchKey(event.key.toLowerCase(), true);
    };

    private readonly onKeyUp: KeyboardEventListener = (event: KeyboardEvent): void => {
        this.dispatchKey(event.key.toLowerCase(), false);
    };
    
    private dispatchKey(key: string, state: boolean): void
    {
        switch (key) {
            case 'arrowup':
                this.dispatch('button-up', state);
                return;
            case 'arrowdown':
                this.dispatch('button-down', state);
                return;
            case 'arrowleft':
                this.dispatch('button-left', state);
                return;
            case 'arrowright':
                this.dispatch('button-right', state);
                return;
            case 'x':
                this.dispatch('button-a', state);
                return;
            case 'z':
                this.dispatch('button-b', state);
                return;
            case 'enter':
            case 'return':
                this.dispatch('button-start', state);
                return;
            case 'shift':
            case 'control':
                this.dispatch('button-select', state);
                return;
        }
    }
}

type KeyboardEventListener = (event: KeyboardEvent) => void;
